import type { DOMPurify as DOMPurifyType } from 'dompurify';
import dompurify from 'dompurify';

export const DomPurify = {
  sanitize: (source: string, config: Parameters<DOMPurifyType['sanitize']>[1] = {}): string => {
    const result = dompurify.sanitize(source, {
      USE_PROFILES: {
        html: true
      },
      ...config,
      ADD_ATTR: ['target', 'rel'],
      RETURN_DOM_FRAGMENT: false,
      RETURN_DOM: false
    });
    return String(result);
  },
  // удалить все тэги
  text: (source: string): string => {
    return DomPurify.sanitize(source, {
      USE_PROFILES: {
        html: false
      }
    });
  }
};
